import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router/index.js'
import config from './config/config'
import cookie from './utils/cookie';
import AppConfig from './data/app-config';
import store from './store/index'
import i18n from "./lang/index"
import { isAuthed, trackPageView } from './plugins/globalFn'
import globalRegist from './plugins/globalRegist';

Vue.use(globalRegist);

AppConfig.getConfig().then(d=>{
    Object.assign(config, d);

    const { cookie_expires } = config;
    cookie.setDefaults({expires: cookie_expires, path: '/'});

    Vue.config.productionTip = false;

    router.beforeEach(async (to, from, next) => {
        // 程序首次打开的时候会有一个使用说明的指导，以后不显示
        if(to.name !== 'instruction'){ // 一定要排除这个页面的判断，负责会死循环
          const hasSeenInstruction = localStorage.getItem("hasSeenInstruction");
          if(hasSeenInstruction !== "true"){
            next(false);
            router.push({
              name: 'instruction'
            });
          }
        }

        // 登录cookie验证
        if(to.meta && to.meta.requireAuth){
            if(!cookie.getCookie(config.tokenId) || !cookie.getCookie(config.userId) || !cookie.getCookie(config.userCode)){
                next(false);
                router.push({
                    name: 'login',
                    query: {
                        redirectUrl: to.name
                    }
                })
            }else{
                if(to.name != "reservationCode"){
                    const auth = await isAuthed();
                    if(!auth){
                        next(false);
                        router.push({
                          name: 'reservationCode'
                        })
                    }
                }
            }
        }

        next();
    });
    router.afterEach((to, from) => {
      try{
        trackPageView(to);// 统计页面曝光
      }catch (err){
        console.log(err);
      }

        var title = document.getElementsByTagName("title")[0];
        if(to.meta && to.meta.title){
            title.innerHTML = i18n.t(to.meta.title);
        }
    });
    /* eslint-disable no-new */

    new Vue({
        store,
        i18n,
        router,
        render: h => h(App)
    }).$mount('#app-box');
},err=>{});




// WEBPACK FOOTER //
// ./src/main.js